
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../components/feature/Footer';
import Navbar from '../../components/feature/Navbar';
import { getVolunteerOpportunities, submitVolunteerApplication } from '../../api/apiServices';

export default function VolunteerPage() {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    interestOption: '',
    interest: '',
    availability: '',
    experience: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('idle');
  const [opportunities, setOpportunities] = useState([]);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
  
    useEffect(() => {
        fetchOpportunities();
      }, []);
    
      const fetchOpportunities = async () => {
        try {
          setLoading(true);
          const res = await getVolunteerOpportunities();
          setOpportunities(res.data || []);
        } catch (err) {
          console.error("Failed to fetch opportunities", err);
        } finally {
          setLoading(false);
        }
      };

  const benefits = [
    { icon: 'ri-heart-line', text: 'Make a meaningful impact in survivors\' lives' },
    { icon: 'ri-team-line', text: 'Join a supportive community of like-minded individuals' },
    { icon: 'ri-book-open-line', text: 'Receive comprehensive training and ongoing support' },
    { icon: 'ri-award-line', text: 'Gain valuable experience and skills' },
    { icon: 'ri-calendar-check-line', text: 'Flexible scheduling to fit your lifestyle' },
    { icon: 'ri-star-line', text: 'Recognition for your contributions' }
  ];

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    setIsSubmitting(true);
    setSubmitStatus('idle');

    await submitVolunteerApplication({
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      interest: formData.interest,
      availability: formData.availability,
      experience: formData.experience,
      message: formData.message,
    });

    setSuccess(true);
    setFormData({
      name: "",
      email: "",
      phone: "",
      interest: "",
      availability: "",
      experience: "",
      message: "",
    });
  } catch (error) {
    console.error("Volunteer submission failed:", error);
    setError(true);
  } finally {
    setIsSubmitting(false);
  }
};


  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative pt-20 sm:pt-24">
        <div className="relative h-[350px] sm:h-[450px]">
          <img
            src="https://readdy.ai/api/search-image?query=diverse%20group%20of%20volunteers%20working%20together%20with%20enthusiasm%20and%20joy%2C%20bright%20natural%20lighting%2C%20simple%20clean%20background%2C%20showing%20teamwork%20and%20dedication%20to%20humanitarian%20cause%2C%20genuine%20smiles%20and%20positive%20energy%2C%20professional%20photography%20capturing%20the%20spirit%20of%20giving&width=1920&height=600&seq=volunteer-hero-001&orientation=landscape"
            alt="Join Our Volunteers"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#6a4bc3]/90 to-[#6a4bc3]/70"></div>
          <div className="absolute inset-0 flex items-center">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20 w-full">
              <p className="text-white/80 text-sm mb-3">JOIN OUR MISSION</p>
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6">
                Become a Volunteer
              </h1>
              <p className="text-white/90 text-base sm:text-lg max-w-xl mb-8">
                Your time and skills can make a profound difference in the lives of survivors. Join our community of dedicated volunteers.
              </p>
              <button
                onClick={() => setShowForm(true)}
                className="bg-[#c9a24d] text-white px-8 py-3 rounded-full font-semibold hover:bg-[#b8923d] transition-all hover:shadow-xl cursor-pointer whitespace-nowrap"
              >
                Apply Now
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-20 bg-[#f8f6fc]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
              Why Volunteer With Us?
            </h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-center gap-4 bg-white p-4 sm:p-5 rounded-xl">
                <div className="w-10 h-10 bg-[#6a4bc3]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className={`${benefit.icon} text-lg text-[#6a4bc3]`}></i>
                </div>
                <p className="text-gray-700 text-sm">{benefit.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Opportunities Section */}
      <section className="py-12 sm:py-20 px-4 sm:px-6 lg:px-20">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 sm:mb-12">
            <p className="text-[#c9a24d] text-sm font-semibold mb-3">OPPORTUNITIES</p>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Ways to Get Involved
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              We have various volunteer opportunities to match your skills, interests, and availability.
            </p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {opportunities.map((opportunity, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-6 sm:p-8 shadow-sm hover:shadow-lg transition-all border border-gray-100 group"
              >
                <div className="w-14 h-14 bg-[#6a4bc3]/10 rounded-full flex items-center justify-center mb-4 group-hover:bg-[#6a4bc3] transition-colors">
                  <i className={`${opportunity.icon} text-2xl text-[#6a4bc3] group-hover:text-white transition-colors`}></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{opportunity.title}</h3>
                <p className="text-gray-600 text-sm mb-4">{opportunity.description}</p>
                {/* <div className="space-y-2 text-xs">
                  <div className="flex items-center gap-2 text-gray-500">
                    <i className="ri-time-line"></i>
                    <span>{opportunity.commitment}</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-500">
                    <i className="ri-checkbox-circle-line"></i>
                    <span>{opportunity.requirements}</span>
                  </div>
                </div> */}
              </div>
            ))}
          </div>
          <div className="text-center mt-10">
            <button
              onClick={() => setShowForm(true)}
              className="bg-[#6a4bc3] text-white px-10 py-4 rounded-full font-semibold hover:bg-[#5a3ba3] transition-all hover:shadow-xl cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
            >
              Apply to Volunteer
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-20 bg-[#6a4bc3]">
        <div className="max-w-4xl mx-auto text-center">
          <i className="ri-double-quotes-l text-5xl text-[#c9a24d] mb-6"></i>
          <blockquote className="text-white text-lg sm:text-xl leading-relaxed mb-6">
            "Volunteering with Okoli Foundation has been one of the most rewarding experiences of my life. Seeing survivors regain their confidence and rebuild their lives reminds me why this work matters so much."
          </blockquote>
          <p className="text-white/90 font-semibold">— James W., Volunteer Mentor</p>
        </div>
      </section>

      {/* Application Form Modal */}
      {showForm && (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4 sm:p-6" onClick={() => setShowForm(false)}>
          <div className="bg-white rounded-2xl sm:rounded-3xl max-w-2xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="p-6 sm:p-10">
              <div className="flex items-center justify-between mb-6 sm:mb-8">
                <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold text-[#6a4bc3]">Volunteer Application</h3>
                <button
                  onClick={() => setShowForm(false)}
                  className="w-10 h-10 flex items-center justify-center text-gray-500 hover:text-gray-700 transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>

              <form id="volunteer-page-form" data-readdy-form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Full Name *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6a4bc3] text-sm"
                    placeholder="Enter your full name"
                  />
                </div>

                <div className="grid sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Email Address *
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6a4bc3] text-sm"
                      placeholder="your.email@example.com"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Phone Number *
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6a4bc3] text-sm"
                      placeholder="(123) 456-7890"
                    />
                  </div>
                </div>

                <div className="grid sm:grid-cols-2 gap-4">
                  <div>
  <label className="block text-sm font-semibold text-gray-700 mb-2">
    Area of Interest *
  </label>

  <select
    value={formData.interestOption || ""}
    onChange={(e) => {
      const value = e.target.value;

      if (value === "Other") {
        setFormData({
          ...formData,
          interestOption: "Other",
          interest: "",
        });
      } else {
        setFormData({
          ...formData,
          interestOption: value,
          interest: value,
        });
      }
    }}
    required
    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6a4bc3] text-sm cursor-pointer"
  >
    <option value="">Select an area</option>
    <option value="Crisis Counseling">Crisis Counseling</option>
    <option value="Advocacy Work">Advocacy Work</option>
    <option value="Fundraising">Fundraising</option>
    <option value="Awareness Campaigns">Awareness Campaigns</option>
    <option value="Mentorship">Mentorship</option>
    <option value="Administrative Support">Administrative Support</option>
    <option value="Other">Other</option>
  </select>

  {/* Show only if Other is selected */}
  {formData.interestOption === "Other" && (
    <input
      type="text"
      placeholder="Please specify"
      value={formData.interest}
      onChange={(e) =>
        setFormData({ ...formData, interest: e.target.value })
      }
      required
      className="mt-3 w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6a4bc3] text-sm"
    />
  )}
</div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Availability *
                    </label>
                    <select
                      name="availability"
                      value={formData.availability}
                      onChange={(e) => setFormData({ ...formData, availability: e.target.value })}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6a4bc3] text-sm cursor-pointer"
                    >
                      <option value="">Select your availability</option>
                      <option value="Weekdays">Weekdays</option>
                      <option value="Weekends">Weekends</option>
                      <option value="Evenings">Evenings</option>
                      <option value="Flexible">Flexible</option>
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Relevant Experience
                  </label>
                  <input
                    type="text"
                    name="experience"
                    value={formData.experience}
                    onChange={(e) => setFormData({ ...formData, experience: e.target.value })}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6a4bc3] text-sm"
                    placeholder="Brief description of relevant experience"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Why do you want to volunteer? *
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={(e) => {
                      if (e.target.value.length <= 500) {
                        setFormData({ ...formData, message: e.target.value });
                      }
                    }}
                    required
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6a4bc3] text-sm resize-none"
                    placeholder="Tell us about your motivation..."
                  />
                  <p className="text-xs text-gray-500 mt-1">{formData.message.length}/500 characters</p>
                </div>

                {submitStatus === 'success' && (
                  <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg text-sm">
                    Thank you for applying! We'll be in touch soon.
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg text-sm">
                    Something went wrong. Please try again.
                  </div>
                )}

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-[#6a4bc3] text-white py-3 sm:py-4 rounded-full font-semibold hover:bg-[#5a3ba3] transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                >
                  {isSubmitting ? 'Submitting...' : 'Submit Application'}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
